import * as R from 'ramda';
import * as types from './types';
import { InvoicesService, GetInvoiceDetails } from '../../services/invoices.service';
import { createHttpGetOptions, HttpClient } from '../../../../services/http/http-client';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { MODIFICATION_URL } from '../../../booking/services/booking-service';
import { ContactsService } from '../../../contacts/services/contacts.service';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getTabsFromDetailsDict, implementSetAllNavTabDetailsAction, implementDeleteNavTabAction, implementSetSingleNavTabDetailsAction, updateSingleNavTabDetails, getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../../router';
import { wait } from '../../../../utility';
import { ACCOUNTING_URL } from '../../../../services/common-urls';
import { sum } from 'ramda';
import { InvoiceForwardService } from '../../services/invoice-forward.service';
import { isEmpty } from 'ramda';
import { EOL_REACHED } from '../../../../dt-plugins/advanced-search/load.model';
import { GlobalActionFlags } from '../../../../store/global';
let invoiceListSource;
let invoiceDetailsSource;


const NavTabModule = getNavTabModule(types.InvoiceDetails, 'invoiceDetails', {
  ListAction: types.InvoiceList
});

export const invoiceActions = {
  async [types.InvoiceData.FETCH.ALL]({ commit }, payload) {
    const invoiceData = await InvoicesService.findInvoiceData();
    // console.log("Log: invoiceData", invoiceData)

    commit(types.InvoiceData.SET.ALL, invoiceData.data);
  },

  async [types.ForwardPayments.INSERT.SINGLE]({ commit }, payload) {
    const invoiceData = await InvoiceForwardService.postArtistPayments(payload);
    // console.log("Log: invoiceData", invoiceData)

    //commit(types.InvoiceData.SET.ALL, invoiceData.data);
  },




  async [types.InvoiceListFilter.UPDATE.ALL]({ commit, getters, state }, payload) {
    // console.log({ 'actions.js:43 payload': payload });
    commit(types.InvoiceListFilter.SET.ALL, {
      ...getters.invoiceListFilter,
      ...payload,
    });
  },
  async [types.InvoiceList.FETCH.ALL]({ commit, getters, state }, payload) {
    invoiceListSource && invoiceListSource.cancel(REQUEST_CANCELLED);
    invoiceListSource = HttpLib.CancelToken.source();

    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;
    // console.log({ 'actions.js:52 payload': payload });
    let res;

    if (searchMode === 'none') {
      if (start === 0) {
        res = await await InvoicesService.searchScollInvoices({}, createHttpGetOptions({
          cancelToken: invoiceListSource.token
        }));
        commit(types.InvoiceList.SET.ALL, res.data);
      } else {
        res = await await InvoicesService.searchScollInvoices({
          start,
        }, createHttpGetOptions({
          cancelToken: invoiceListSource.token
        }));
        commit(types.InvoiceList.SET.ALL, [
          ...getters.invoiceList,
          ...res.data
        ]);

        // Setting EOL
        if (!(res?.data?.length > 0)) {
          return EOL_REACHED;
        }
      }

    } else if (searchMode === 'basic') {
      const {
        searchString,
        invoice_project_id,
        invoice_user_id,
        invoiceStatuses } = basicFilter;
      res = await await InvoicesService.searchScollInvoices({
        searchString,
        invoice_project_id,
        invoice_user_id,
        invoiceStatuses,
        start
      }, createHttpGetOptions({
        cancelToken: invoiceListSource.token
      }));
      if (start === 0) {
        commit(types.InvoiceList.SET.ALL, res.data);
      } else {
        commit(types.InvoiceList.SET.ALL, [
          ...getters.invoiceList,
          ...res.data
        ]);
      }
      // Setting EOL
      if (!(res?.data?.length > 0)) {
        return EOL_REACHED;
      }
    } else if (searchMode === 'advanced') {
      // console.log({ "searchFilter": searchFilter });
      res = await InvoicesService.advance_search({
        ...searchFilter,
        row_start: start
      }, createHttpGetOptions({
        cancelToken: invoiceListSource.token
      }));

      if (start === 0) {
        commit(types.InvoiceList.SET.ALL, res.data.invoices);
      } else {
        commit(types.InvoiceList.SET.ALL, [
          ...getters.invoiceList,
          ...res.data.invoices
        ]);
      }
      // Setting EOL
      if (!(res?.data?.invoices?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },
  async [types.InvoiceList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { invoice_id } = payload;
    const noDatabaseUpdate = payload?.[GlobalActionFlags.noDatabaseUpdate];

    console.log("DELETE PAYLOAD", payload);

    commit(types.InvoiceList.SET.ALL, getters.invoiceList.filter(invoice => invoice.invoice_id !== invoice_id));

    if (!noDatabaseUpdate) {
      await InvoicesService.deleteInvoice({ invoice_id });
    }
  },
  async [types.InvoiceList.SEARCH.ALL]({ commit }, payload) {
    const {
      search_str,
      invoiceStatuses,
      invoice_project_id,
      invoice_user_id
    } = payload;

    invoiceListSource && invoiceListSource.cancel(REQUEST_CANCELLED);
    invoiceListSource = HttpLib.CancelToken.source();

    const invoiceList = await InvoicesService.searchInvoices({
      search_str,
      invoiceStatuses,
      invoice_project_id,
      invoice_user_id,
    }, createHttpGetOptions({
      cancelToken: invoiceListSource.token
    }));

    commit(types.InvoiceList.SET.ALL, invoiceList.data);
  },

  // Invoice Lines Actions






  // TABULATION IMPLEMENTATION
  // TABULATION IMPLEMENTATION
  // TODO: Nest all Store Functions under this section
  // TABULATION IMPLEMENTATION
  // TABULATION IMPLEMENTATION

  async [types.InvoiceDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, invoice, reload } = payload;

    flag = typeof flag === 'boolean' ? flag : true;

    setMainNavInactive(commit, flag);

    // if (!flag) {
    //   return;
    // }

    const primaryKey = 'invoice_id';
    const itemName = 'invoice';
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = 'invoiceDetails';
    const DetailsAction = types.InvoiceDetails;


    // Check Reload and prexisting Item Logic

    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }


    // dispatch(DetailsAction.SET.ALL, {
    //   ...getters[detailsGetterKey],
    //   [primaryKeyValue]: {
    //     [itemName]: item,
    //     loading: true,
    //   },
    // });

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true,
      }
    })

    // HTTP Req

    const detailsResponse = await GetInvoiceDetails({
      invoice_id: invoice.invoice_id
    });

    console.log(detailsResponse, "INVOICE DETAILS RESP")

    // Setting the Details Dict Response

    // dispatch(DetailsAction.SET.ALL, {
    //   ...getters[detailsGetterKey],
    //   [primaryKeyValue]: {
    //     ...detailsResponse,
    //     loading: false,
    //   },
    // });

    // console.log("::::", detailsResponse);

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, (detailsDict, invoice) => {
      return {
        ...invoice,
        ...detailsResponse,
        loading: false,
      }
    })
  },
  ...NavTabModule.implementActions(
    'invoice_id',
    'invoices/invoice_id/tab',
    'invoices',
    () => router,
    'accounting',
    (value, key) => {
      return {
        title: value?.invoice?.invoice_ref ? `${value?.invoice?.invoice_ref}` : key,
        full_title: `${value?.invoice?.invoice_ref} ${value?.invoice?.invoice_address} ${value?.invoice?.subject}`,
      }
    }
  ),
  // ...implementDeleteNavTabAction(
  //   types.InvoiceDetails,
  //   'invoiceDetails',
  //   'invoice_id',
  //   'invoices/invoice_id/tab',
  //   'invoices',
  //   () => router
  // ),

  async [types.UPDATE_VAT_NO]({ commit, getters, dispatch }, payload) {
    // console.log(payload);
    const { name, value, contact_id, item } = payload;

    const { invoice_id } = item?.invoice;

    if (!invoice_id) {
      throw Error('Pass a valid invoice as the item');
    }

    const NavTabHelper = NavTabModule.Helper(dispatch, getters)


    NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
      return {
        vatIdValidityLoading: true,
        contact: {
          ...invoiceObj.contact,
          vat_no: value
        },
      }
    })

    const updateVatNo = await InvoicesService.updateVatNo({
      contact_id,
      value
    });

    await wait(1000);

    const checkValid = await ContactsService.checkInvoiceVatIdFlag({
      vat_no: value,
      contact_id,
    });

    const { valid_vat_no_flag } = checkValid.data;


    NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
      return {
        check_vat_id: valid_vat_no_flag,
        vatIdValidityLoading: false,
      }
    })

  },
  async [types.InvoiceDetails.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    // console.log(payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, data } = payload;
    const { invoice } = item;
    const { invoice_id, contact_id } = invoice;

    const invoiceOB = getters.invoiceDetails[invoice_id];

    // console.log("OBI WAN KENOBI", invoiceOB);

    const key = ['debitor_no', 'tax_no'].includes(name)
      ? 'contact_id'
      : ['vat_rate1', 'vat_rate2'].includes(name) ? 'invoice_id' : 'invoice_id';

    const kVal = invoice[key];

    const table = key === 'invoice_id'
      ? 'invoices'
      : 'contacts';


    NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
      return {
        ...invoiceObj,
        invoice: {
          ...invoiceObj.invoice,
          [name]: value,
        }
      }
    });


    if (['vat_rate1', 'vat_rate2'].includes(name)) {
      const updateInvoice = await HttpClient.post(MODIFICATION_URL, {
        kVal,
        name,
        value,
        table: 'invoices',
        modify_type: '',
        json_op: '',
        json_key: ''
      });
      dispatch(types.FETCH_ONLY_INVOICE, { invoice });
    }
    if (['vat_territory'].includes(name)) {
      const updateInvoice = await HttpClient.post(MODIFICATION_URL, {
        kVal,
        vat_territory: data.vat_territory,
        vat_rate1: data.vat_rate1,
        vat_rate2: data.vat_rate2,
        table: 'invoices',
        modify_type: 'record',
        json_op: '',
        json_key: ''
      });

      dispatch(types.FETCH_ONLY_INVOICE, { invoice });
    }
    else if (['invoice_project_id'].includes(name)) {
      const toInvoiceProject = invoiceOB.invoice_projects.find(e => e.invoice_project_id == value)
      const invoice_coutry = toInvoiceProject.country || "";
      const contact_country = invoiceOB.contact.country || "";
      let vat_handling = "";
      let tax_type_id_deduction = "";
      // console.log("INVOICEOB::::", value, invoiceOB, invoice_coutry, contact_country, toInvoiceProject)
      if (invoice_coutry.toLowerCase() == contact_country.toLowerCase()) {
        vat_handling = 1;
      }
      else {
        vat_handling = 3;
        tax_type_id_deduction = '';
      }
      const updateInvoice = await InvoicesService.changeInvoiceProject(
        invoiceOB.invoice.invoice_id,
        value,
        invoiceOB.invoice.payment_method_id,
        invoiceOB.invoice.money_account_id,
        toInvoiceProject.vat_rate1,
        toInvoiceProject.vat_rate2,
        invoiceOB.invoice.vat_rate3,
        vat_handling,
        tax_type_id_deduction

      )
      // console.log("updateInvoice :::", updateInvoice, { invoice })
      // dispatch(types.FETCH_ONLY_INVOICE, { invoice });
      dispatch(types.InvoiceDetails.FETCH.SINGLE, {
        flag: true,
        invoice: invoice,
        reload: true,
      });

    }
    else {
      const updateInvoice = await HttpClient.modify(
        key,
        kVal,
        name,
        value,
        table
      );
    }

  },
  async [types.LOCK_INVOICE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { from, item } = payload;
    const { invoice } = item;

    const { invoice_id, lock_flag } = invoice;

    const newFlag = lock_flag == "1" ? "0" : "1";

    if (from == 'list') {
      commit(types.InvoiceList.UPDATE.SINGLE, {
        invoice_id,
        update: {
          lock_flag: 'LOADING'
        }
      });


      const updateLockFlag = await InvoicesService.lockInvoice({
        invoice_id,
        lock_flag: newFlag
      });

      commit(types.InvoiceList.UPDATE.SINGLE, {
        invoice_id,
        update: {
          lock_flag: newFlag
        }
      });
      NavTabHelper.updateSingleNavTabDetailsIfExist(invoice_id, (invoiceObj) => {
        return {
          invoice: {
            ...invoiceObj.invoice,
            lock_flag: newFlag
          },
        };
      });
    } else if (from == 'details') {

      NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
        return {
          invoice: {
            ...invoiceObj.invoice,
            lock_flag: 'LOADING'
          },
        };
      })

      const updateLockFlag = await InvoicesService.lockInvoice({
        invoice_id,
        lock_flag: newFlag
      });

      NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
        return {
          invoice: {
            ...invoiceObj.invoice,
            lock_flag: newFlag
          },
        };
      })
    }
  },



  async [types.CHANGE_TAX_DEDUC]({ commit, getters, dispatch }, payload) {
    // console.log(payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const {
      vat_handling,
      tax_type_id_deduction,
      item
    } = payload;
    const { invoice } = item;
    const { invoice_id } = invoice;



    NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
      return {
        invoice: {
          ...invoiceObj.invoice,
          vat_handling,
          tax_type_id_deduction,
        },
      }
    })

    const updateVatHandle = await InvoicesService.changeTaxDeduction({
      invoice_id,
      vat_handling,
      tax_type_id_deduction
    });


    dispatch(types.FETCH_ONLY_INVOICE, { invoice: item });
  },

  async [types.InvoiceLines.UPDATE.SINGLE]({ commit, dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const { name, value, item, invoice } = payload;
    const { invoice_id } = invoice;

    const key = 'invoiceline_id';
    const kVal = item[key];
    const table = 'invoicelines';

    const oldValue = item[name];
    if (oldValue == value) {
      return;
    }


    NavTabHelper.updateSingleNavTabDetails(invoice_id, (invoiceObj) => {
      return {
        ...invoiceObj,
        invoicelines: invoiceObj.invoicelines.map(il => {
          if (il.invoiceline_id == item.invoiceline_id) {
            return {
              ...il,
              [name]: value,
            };
          } else {
            return il;
          }
        })
      }
    })

    const updateInvoiceLine = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

    // Refetch the Invoice Details if the Invoice Lines Quantity or 
    // the Price is modified after another value

    // console.log(updateInvoiceLine);

    if (
      (name === 'qty' && item.price) ||
      (name === 'price' && item.qty) ||
      (name == 'vat_type' && item.qty && item.price)
    ) {
      dispatch(types.FETCH_ONLY_INVOICE, { invoice });
    }
  },
  async [types.FETCH_ONLY_INVOICE]({ getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { invoice } = payload;

    if (!invoice) {
      throw Error('Invoice was not passed as action argument');
    }

    const { invoice_id } = invoice;


    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        loading: true,
      }
    })

    // DEPCRECATED_COMMENT: Forwarding Tab has a small response size that includes Only Invoice Object

    const invoiceLineData = await InvoicesService.getInvoiceLineData({
      invoice_id: invoice.invoice_id
    });


    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        invoice: invoiceLineData?.data?.invoice,
        loading: false,
      }
    })
  },
  async [types.Payments.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, invoice } = payload;

    const { invoice_id } = invoice;

    const key = 'payment_id';
    const kVal = item[key];
    const table = 'payments';

    if (name !== 'currency_id') {



      NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
        const payments = invoiceObj.payments.map(pmnt => {
          if (pmnt[key] == kVal) {
            return {
              ...pmnt,
              [name]: value
            };
          } else {
            return pmnt;
          }
        });

        const currency_id = invoice?.invoice?.currency_id;

        const payment_total = sumPayments(payments);

        if (allPaymentsSameCurrency(payments, currency_id)) {
          return {
            payments,
            payment_total,
          }
        }
        return {
          payments,
          payment_total: 0,
        }
      })

      const updatePayment = await HttpClient.modify(
        key,
        kVal,
        name,
        value,
        table
      );
    }

    else {
      const newCurrencyExchangeRate = (NavTabHelper.getSingDet(invoice_id).currencies.find(c => c.currency_id == value) || {})['exchange_rate'];


      NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
        const payments = invoiceObj.payments.map(pmnt => {
          if (pmnt[key] == kVal) {
            return {
              ...pmnt,
              [name]: value,
              exchangerate: newCurrencyExchangeRate
            };
          } else {
            return pmnt;
          }
        });

        const currency_id = invoice?.invoice?.currency_id;

        const payment_total = sumPayments(payments);

        if (allPaymentsSameCurrency(payments, currency_id)) {
          return {
            payments,
            payment_total,
          }
        }
        return {
          payments,
          payment_total: 0,
        }
      })

      const updatePaymentCurr = await HttpClient.post(MODIFICATION_URL, {
        modify_type: 'record',
        table,
        kVal,
        currency_id: value,
        exchangerate: newCurrencyExchangeRate
      });
    }

  },
  async [types.Payments.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item, invoice } = payload;
    const { payment_id } = item;
    const { invoice_id } = invoice;

    // console.log(invoice, item);

    let deltedPayment;
    if (payment_id) {
      deltedPayment = await HttpClient.post(ACCOUNTING_URL, {
        section: 'invoices',
        action: 'delete_payment',
        payment_id
      });
    } else {
      console.error('Payment ID is not Defined');
    }

    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        payments: invoiceObj.payments.filter(pmnt => {
          if (pmnt.payment_id == payment_id) {
            return false;
          } else {
            return true;
          }
        })
      }
    })
  },

  async [types.InvoiceLines.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { invoice } = payload;
    const { invoice_id } = invoice;

    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        loading: true,
      }
    });


    const newInvoiceLine = await InvoicesService.createNewInvoiceLine({
      invoice_id,
    });
    // console.log("Log: newInvoiceLine", newInvoiceLine);


    const key = 'invoiceline_id';
    const table = 'invoicelines';

    let defaultQtyAssign = false;

    for (let invoiceline of newInvoiceLine.data.invoicelines) {
      if (!invoiceline.qty) {
        defaultQtyAssign = true;
        await HttpClient.modify(
          key,
          invoiceline.invoiceline_id,
          'qty',
          '1',
          table
        );
      }
    }

    if (!defaultQtyAssign) {

      NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
        return {
          invoicelines: newInvoiceLine.data.invoicelines
        };
      })

    } else {
      await dispatch(types.InvoiceLines.FETCH.ALL, { invoice });
    }
    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        loading: false,
      };
    })
  },

  async [types.InvoiceLines.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { invoice } = payload;
    const { invoice_id } = invoice;

    const newInvoiceLine = await InvoicesService.getInvoiceLineData({
      invoice_id
    });

    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        invoicelines: newInvoiceLine.data.invoicelines
      };
    });
  },
  async [types.InvoiceLines.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { invoiceline_id, invoice } = payload;
    const { invoice_id } = invoice;


    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        loading: true,
        invoicelines: invoiceObj.invoicelines.
          filter(il => il.invoiceline_id != invoiceline_id)
      }
    })

    const deletedInvoiceLine = await InvoicesService.removeInvoiceLine({
      invoiceline_id
    });

    dispatch(types.FETCH_ONLY_INVOICE, { invoice });
  },


  // ArtistPayments Actions

  async [types.ArtistPayments.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { item } = payload
    const { invoice_id } = item;

    // console.log("PAYLOAD", payload)
    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        loading: true,
      }
    });
    const newInvoiceLine = item.artist_payments.length > 0 ? await InvoiceForwardService.postArtistPayments(invoice_id, item.artist_payments[0].recipient) : await InvoiceForwardService.postArtistPayments(invoice_id, "")
    // console.log("WWWWWWW", payload)
    // if(item.artist_payments.length>0)
    // {
    //    newInvoiceLine = await InvoiceForwardService.postArtistPayments(invoice_id,item.artist_payments[0].recipient)
    // }
    // else
    // {
    //    newInvoiceLine=await InvoiceForwardService.postArtistPayments(invoice_id,"")
    // }

    // console.log("Log: newInvoiceLine", newInvoiceLine);
    await dispatch(types.ArtistPayments.FETCH.ALL, payload);
  },

  async [types.ArtistPayments.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { item } = payload;
    const { invoice_id } = item;

    const artist_payments = await InvoiceForwardService.getIvoiceDetails(invoice_id);
    // console.log("RRRRRRRR", artist_payments)
    NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
      return {
        artist_payments: artist_payments.data.artist_payments,
        loading: false,
      };
    });

    // console.log(":::::::", artist_payments)
  },
  async [types.ArtistPayments.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const { name, item, value, artist } = payload

    const { invoice_id } = item

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    // console.log("PAYLOAD", payload)
    // NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
    //   return {
    //     loading: true,
    //   }
    // });


    const newInvoiceLine = await InvoiceForwardService.updateArtistpayments(artist.payment_id, value, name)
    // console.log("Log: newInvoiceLine", newInvoiceLine);
    await dispatch(types.ArtistPayments.FETCH.ALL, payload);
  },

  async [types.ArtistPayments.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {

    const { payment_id, item } = payload
    // const {item}=payload
    // const {value}=payload

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    // console.log("PAYLOAD",payload.invoice_id)
    NavTabHelper.updateSingleNavTabDetails(item.invoice_id, invoiceObj => {
      return {
        loading: true,
      }
    });


    const newInvoiceLine = await InvoiceForwardService.deleteArtistPayments(payment_id)
    //console.log("Log: newInvoiceLine", newInvoiceLine);
    await dispatch(types.ArtistPayments.FETCH.ALL, payload);
  },

};
function sumPayments(payments) {
  return sum(payments.map(p => p.amount));
}

function allPaymentsSameCurrency(payments, currency_id) {
  return currency_id && payments.every(payment => payment.currency_id == currency_id);
}

